import { useForm } from 'react-hook-form';
import { useState } from 'react';
import { ApiService } from './registerServices';




export const FetchData = async () => {

    try {
        const data = await ApiService.getData()
        return (data)

    } catch (error) {
        console.error('Service Error:', error)
        console.error('error response:', error.response)
        throw error
    }
}

export const useSubmitData = () => {

    const [message, setMessage] = useState(null)
    const [response, setResponse] = useState(null)
    const { register, handleSubmit, formState: { errors }, setValue } = useForm({
        mode: "onBlur",
    })

    const onSubmit = async (data) => {
        try {
            console.log('data controler es: ', data)

            // const newObject = {
            //     ...data,
            //     alternativePhoneNumber: data.alternativePhoneNumber?.toString() || '',
            //     alternativePhonePrefixId: data.alternativePhonePrefixId?.toString() || ''
            // }
    
            // console.log("newObject", newObject)


            const result = await ApiService.postData(data)
            setResponse(result.status)

            //console.log('resultado ', result)
            setMessage(result.data.message)



        } catch (error) {
            // console.error('El error del controlador fue: ',error);
            // alert(`${error.message}`)
            // throw error

            setMessage(error.message)
            setResponse(error.status)
        }
    }

    return { register, handleSubmit, onSubmit, setValue, message, errors, response, setMessage, setResponse }

}

